import React from "react";

const TopBar = ({ subtitle }) => (
  <header className="xp-topbar">
    <span className="xp-topbar-icon">
      <i className="fas fa-concierge-bell"></i>
    </span>
    <div className="xp-topbar-text">
      <strong>Pasarela de Pagos</strong>
      <span>{subtitle || "Reservas de hotel · Pago seguro"}</span>
    </div>
  </header>
);

export default TopBar;
